module.exports = __webpack_public_path__ + "static/media/color3.a39c6bdf.PNG";